import { Case } from '../service-case/model/case';
import { NavigationCall } from '../model/navigationCall';
import { OidcToken } from '../oidc/model/oidcToken';
import { OutletConfiguration } from '../outlet/model/outletConfiguration';
import { User } from '../user/model/user';
import { Intercom } from './intercom';
import { Topic } from './topic';
export class ClientApi {
    static mapUserLocaleToEtkLocale(user) {
        switch (user.getLocale()) {
            case 'cs-CZ':
                user.setLocale('cs-CS');
                break;
            case 'el-GR':
                user.setLocale('el-EL');
                break;
            case 'en-GB':
                user.setLocale('en-EN');
                break;
            case 'ja-JP':
                user.setLocale('ja-JA');
                break;
            case 'ko-KR':
                user.setLocale('ko-KO');
                break;
            case 'nb-NO':
                user.setLocale('nn-NO');
                break;
            case 'sv-SE':
                user.setLocale('sv-SV');
                break;
            case 'zh-CN':
                user.setLocale('zh-SI');
                break;
            case 'zh-TW':
                user.setLocale('zh-TR');
                break;
            case 'bg-BG':
            case 'da-DK':
            case 'fi-FI':
            case 'hu-HU':
            case 'ro-RO':
            case 'sl-SI':
                user.setLocale('en-US');
                break;
            default:
                break;
        }
    }
    constructor(actorId) {
        this.subscribeToActiveCase = (onReceiveCallback) => {
            this.intercom.subscribe(Topic.ACTIVE_CASE, (message) => {
                if (message.payload) {
                    onReceiveCallback(Case.constructFromPlainObject(message.payload));
                }
                else {
                    onReceiveCallback(null);
                }
            });
        };
        this.republishActiveCase = () => {
            this.intercom.requestToRepublish(Topic.ACTIVE_CASE);
        };
        this.subscribeToUser = (onReceiveCallback) => {
            this.intercom.subscribe(Topic.ACTIVE_USER, (message) => {
                if (message.payload) {
                    const user = User.constructFromPlainObject(message.payload);
                    if (this.intercom.getActorId() === "PARTS_CATALOGUE") {
                        ClientApi.mapUserLocaleToEtkLocale(user);
                    }
                    onReceiveCallback(user);
                }
                else {
                    onReceiveCallback(null);
                }
            });
        };
        this.republishUser = () => {
            this.intercom.requestToRepublish(Topic.ACTIVE_USER);
        };
        this.subscribeToOutletConfiguration = (onReceiveCallback) => {
            this.intercom.subscribe(Topic.OUTLET_CONFIGURATION, (message) => {
                if (message.payload) {
                    onReceiveCallback(OutletConfiguration.constructFromPlainObject(message.payload));
                }
                else {
                    onReceiveCallback(null);
                }
            });
        };
        this.republishOutletConfiguration = () => {
            this.intercom.requestToRepublish(Topic.OUTLET_CONFIGURATION);
        };
        this.intercom = new Intercom(actorId);
    }
    addDefectsToActiveCase(defects) {
        this.intercom.publish(Topic.ADD_DEFECTS, defects);
    }
    addFlatRateUnitsToActiveCase(flatRateUnits) {
        this.intercom.publish(Topic.ADD_FLAT_RATE_UNITS, flatRateUnits);
    }
    addOrReplaceFlatRateUnitsToActiveCase(flatRateUnits) {
        this.intercom.publish(Topic.ADD_FLAT_RATE_UNITS, flatRateUnits);
    }
    addPackagesToActiveCase(packages) {
        this.intercom.publish(Topic.ADD_PACKAGES, packages);
    }
    addPartsToActiveCase(parts) {
        this.intercom.publish(Topic.ADD_PARTS, parts);
    }
    addJobsToActiveCase(jobs) {
        this.intercom.publish(Topic.ADD_JOBS, jobs);
    }
    addEmptyJobToActiveCase() {
        this.intercom.publish(Topic.ADD_EMPTY_JOB, null);
    }
    removeJobsFromActiveCase(jobs) {
        this.intercom.publish(Topic.REMOVE_JOBS, jobs);
    }
    updateMetaDataInActiveCase(updatedCase) {
        this.intercom.publish(Topic.UPDATE_META_DATA, updatedCase);
    }
    updateJobInActiveCase(job) {
        this.intercom.publish(Topic.UPDATE_JOB, job);
    }
    publishDeletedCase(caseId) {
        this.intercom.publish(Topic.DELETE_CASE, caseId);
    }
    publishConfigurationProperty(configurationProperty) {
        if (configurationProperty) {
            this.intercom.publish(Topic.CONFIGURATION_PROPERTY, configurationProperty);
        }
        else {
            throw new Error('publishConfigurationProperty(null) is not allowed.');
        }
    }
    openServiceCaseByVin(vin) {
        if (vin) {
            this.intercom.publish(Topic.OPEN_CASE_BY_VIN, vin);
        }
        else {
            throw new Error('openServiceCaseByVin(null) is not allowed.');
        }
    }
    subscribeToOidcToken(onReceiveCallback) {
        this.intercom.subscribe(Topic.OIDC_TOKEN, (message) => {
            if (message.payload) {
                onReceiveCallback(OidcToken.constructFromPlainObject(message.payload));
            }
            else {
                throw new Error('Received message without payload for topic OIDC_TOKEN.');
            }
        });
    }
    republishOidcToken() {
        this.intercom.requestToRepublish(Topic.OIDC_TOKEN);
    }
    notifyError(msg) {
        this.intercom.publish(Topic.NOTIFY_ERROR, msg);
    }
    notifyInfo(msg) {
        this.intercom.publish(Topic.NOTIFY_INFO, msg);
    }
    notifySuccess(msg) {
        this.intercom.publish(Topic.NOTIFY_SUCCESS, msg);
    }
    notifyWarning(msg) {
        this.intercom.publish(Topic.NOTIFY_WARNING, msg);
    }
    navigateTo(app, pathParam, queryParams) {
        this.intercom.publish(Topic.NAVIGATE_TO, new NavigationCall(app, pathParam, queryParams));
    }
}
//# sourceMappingURL=clientApi.js.map